const initialState = {
  companyDetails: [
    {
      goods_type: '',
      short_allowance: '',
    }
  ],
};

const ADD_COMPANY_DETAILS = 'ADD_COMPANY_DETAILS';

// Define action creators
export const addCompanyDetails = (details:any) => ({
  type: ADD_COMPANY_DETAILS,
  payload: details,
});

const goodsformReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_COMPANY_DETAILS:
      const { index, ...newDetails } = action.payload;
      const updatedDetails = [...state.companyDetails];
      if (index >= 0 && index < updatedDetails.length) {
        updatedDetails[index] = { ...updatedDetails[index], ...newDetails };
      } else {
        updatedDetails.push(newDetails);
      }
      return {
        ...state,
        companyDetails: updatedDetails,
      }
    default:
      return state;
  }
};

export default goodsformReducer;
